import { defaultClosingRange } from '../../constants/compound';

const fetchInitialState = {
  fetching: false,
  segments: [],
};

const fetch = (state = fetchInitialState, action) => {
  switch (action.type) {
    case 'FETCH_SEGMENTS':
      return {
        ...state,
        fetching: true,
      };

    case 'FETCH_SEGMENTS_SUCCESS':
      return {
        ...state,
        fetching: false,
        segments: action.segments.map((segment) => ({
          ...segment,
          steps: segment.steps.map((step) => ({
            ...step,
            closingRange: step.closingRange || defaultClosingRange,
          })),
        })),
      };

    case 'FETCH_SEGMENTS_FAILURE':
      return {
        ...state,
        fetching: false,
      };

    case 'UPDATE_SEGMENT_SUCCESS': {
      if (!action.id) {
        return {
          ...state,
          segments: [...state.segments, action.segment],
        };
      }

      const editedIndex = state.segments.findIndex((f) => f.id === action.segment.id);

      return {
        ...state,
        segments: [
          ...state.segments.slice(0, editedIndex),
          action.segment,
          ...state.segments.slice(editedIndex + 1),
        ],
      };
    }

    case 'DELETE_SEGMENT_SUCCESS': {
      const deletedIndex = state.segments.findIndex((f) => f.id === action.id);

      return {
        ...state,
        segments: [
          ...state.segments.slice(0, deletedIndex),
          ...state.segments.slice(deletedIndex + 1),
        ],
      };
    }

    default:
      return state;
  }
};

export default fetch;

export const areFetching = (state) => state.fetching;

export const getSegments = (state) => state.segments;
